module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-PP.bdd86c6d.png";